import * as yup from 'yup'


const NotificationSchema = yup.object().shape({
    userId: yup.number().required("Please select user"),
    message: yup.string().trim().required("Please enter issue description"),
    escalationType: yup.string().trim().required("Please select escalation type"),
    priorityId: yup.number().required("Please select priority")
})

const notificationInitialState = {
    userId: null,
    message: "",
    escalationType: "Client",
    priorityId: 2
}

export { NotificationSchema, notificationInitialState }